// @generated by protoc-gen-connect-es v1.4.0
// @generated from file penumbra/core/component/shielded_pool/v1/shielded_pool.proto (package penumbra.core.component.shielded_pool.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AssetMetadataByIdRequest, AssetMetadataByIdResponse, AssetMetadataByIdsRequest, AssetMetadataByIdsResponse } from "@buf/penumbra-zone_penumbra.bufbuild_es/penumbra/core/component/shielded_pool/v1/shielded_pool_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * Query operations for the shielded pool component.
 *
 * @generated from service penumbra.core.component.shielded_pool.v1.QueryService
 */
export const QueryService = {
  typeName: "penumbra.core.component.shielded_pool.v1.QueryService",
  methods: {
    /**
     * @generated from rpc penumbra.core.component.shielded_pool.v1.QueryService.AssetMetadataById
     */
    assetMetadataById: {
      name: "AssetMetadataById",
      I: AssetMetadataByIdRequest,
      O: AssetMetadataByIdResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Requests a stream of asset metadata, given an array of asset IDs. Responses
     * may be streamed in a different order from that of the asset IDs in the
     * request, and asset IDs unknown to the node will not receive any response
     * objects -- that is, the number of responses may be smaller than the length
     * of the asset IDs array.
     *
     * @generated from rpc penumbra.core.component.shielded_pool.v1.QueryService.AssetMetadataByIds
     */
    assetMetadataByIds: {
      name: "AssetMetadataByIds",
      I: AssetMetadataByIdsRequest,
      O: AssetMetadataByIdsResponse,
      kind: MethodKind.ServerStreaming,
    },
  }
};

